<div class="reports-container">
  @for (report of reports | async; track report) {
    <mat-card class="report-card">
      <mat-card-title class="report-card-title">
        <div class="title-content">
          <span class="week-text">Week {{ report.weekOfYear }}</span>
          @if (report.lastModifiedDate) {
            <span class="last-modified">(last modified: {{ report.lastModifiedDate | date:'short' }})</span>
          }
        </div>
        @if (canDelete) {
          <button (click)="deleteRow(report)" class="delete-button" mat-icon-button>
            <mat-icon>delete</mat-icon>
          </button>
        }
      </mat-card-title>
      <mat-card-content>
        <div class="report-fields-list">
          @for (field of report.fields; track field) {
            <div class="report-field-item">
              <span class="field-description">
                {{ field.description }}:
                @if (!field.isManual) {
                  <span class="auto-label" i18n>Auto</span>
                }
              </span>
              @if (field.key === 'onTimeOrders' || field.key === 'onTimeOrdersInWeek') {
                <span class="field-value">
                  @for (item of field.value || []; track item; let last = $last) {
                    {{ item.order }}{{ !last ? ', ' : '' }}
                  }
                </span>
              } @else {
                <span class="field-value">{{ field.value }}</span>
              }
            </div>
          }
        </div>
      </mat-card-content>
    </mat-card>
  }
</div>